<div class="row justify-content-md-center py-4">
  <div class="col-md-8">
    <div *ngIf="formContent">
      <ng-container *ngIf="focusState">
        <app-community-focus
          [value]="focusState.value"
          [hidden]="focusState.hidden"
          [disabled]="focusState.disabled"
        ></app-community-focus>
      </ng-container>

      <app-form-constructor [formContent]="formContent"></app-form-constructor>
      <small class="form-text text-muted required-hint" data-test-id="small-required">
        * - {{ 'REQUIRED_FIELD_HINT' | translate }}
      </small>
      <div>
        <button
          *ngIf="community.permissions.remove"
          class="btn btn-outline-primary me-3"
          type="button"
          data-test-id="btn-remove-community"
          (click)="onRemoveCommunity()"
        >
          {{ 'BTN_REMOVE_COMMUNITY_TITLE' | translate }}
        </button>
      </div>
      <div class="py-4">
        <button
          class="btn btn-primary me-3"
          type="submit"
          data-test-id="btn-update-community"
          (click)="submitForm($event)"
        >
          {{ 'BTN_SUBMIT_HINT' | translate }}
        </button>
        <button
          class="btn btn-secondary me-3"
          type="button"
          routerNavigate=""
          data-test-id="btn-cancel-community"
          (click)="onCancel()"
        >
          {{ 'BTN_CANCEL_HINT' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
